import { memo } from 'react';

import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

function EmptyLinkedBankAccount({
  handleLinkBankAccount,
  hasLink = true,
  isFetchingPlaidToken = false
}) {
  return (
    <Stack
      alignItems="center"
      alignSelf="center"
      direction="column"
      paddingTop="32px"
      spacing="16px"
      width="343px"
    >
      <Text
        align="center"
        color="secondary"
      >
        You don&apos;t have any linked bank accounts
      </Text>
      <Text
        align="center"
        color="secondary"
        size="md"
      >
        You need to link a bank account before you can transfer money.
      </Text>

      {hasLink && (
        <Button
          color="info"
          disabled={isFetchingPlaidToken}
          onClick={handleLinkBankAccount}
          size="small"
          variant="text"
        >
          Link a bank account
        </Button>
      )}
    </Stack>
  );
}

export default memo(EmptyLinkedBankAccount);

EmptyLinkedBankAccount.propTypes = {
  handleLinkBankAccount: PropTypes.func.isRequired,
  hasLink: PropTypes.bool,
  isFetchingPlaidToken: PropTypes.bool
};
